export default __webpack_public_path__ + "static/media/SUNNY.8be245cf.svg";